import { useRef, useState } from "react";
import { Tooltip } from "@mui/material";

import styles from "./columns.module.css";

/*
 * The test column sits beside the result preview, so a long list of test names is cut
 * short. It ends in an ellipsis and the full list is a hover away. The table's own cell
 * does this for plain text, but this cell stacks the names over a correction badge, so
 * the names have to clip themselves. The tooltip appears only when they are cut off.
 * Not components/ui/TruncatedText: that one takes a plain string, and the abnormal test
 * names are red spans of their own.
 */
export const TruncatedTestNames = ({ children }) => {
  const textRef = useRef(null);
  const [tooltipTitle, setTooltipTitle] = useState("");

  const handleMouseEnter = () => {
    const element = textRef.current;

    if (!element || element.scrollWidth <= element.clientWidth) return;

    setTooltipTitle(element.textContent.trim());
  };

  return (
    <Tooltip title={tooltipTitle} placement="top" enterDelay={200}>
      <span
        ref={textRef}
        className={styles.truncatedTestNames}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setTooltipTitle("")}
      >
        {children}
      </span>
    </Tooltip>
  );
};
